module.exports = __webpack_public_path__ + "static/media/step-indicator-3.2f91655e.svg";